import { Controller } from "@hotwired/stimulus"

// Retention view filter on the owner Finances dashboard (Phelipe 2026-08-27).
// A small dialog with one dropdown: whether the dashboard totals account for
// retention held. Saves to the user's own settings and reloads, so the figures
// come back already retention-aware — no duplicate money math in the browser.
// It's a per-user preference, so the choice follows them into every project.
export default class extends Controller {
  static targets = ["modal", "select", "saveBtn"]
  static values = { url: String }

  open(event) {
    event?.preventDefault()
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden")
  }

  close() {
    if (this.hasModalTarget) this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async save() {
    if (!this.hasSelectTarget) return
    const next = this.selectTarget.value === "true"
    if (this.hasSaveBtnTarget) this.saveBtnTarget.disabled = true

    try {
      const resp = await fetch(this.urlValue, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        credentials: "same-origin",
        body: JSON.stringify({ setting: { finances_include_retention: next } })
      })
      if (!resp.ok) throw new Error("Couldn't save that")
      window.location.reload()
    } catch (_) {
      // Leave the dialog open and re-enable — the page still shows what the
      // server holds, so nothing is misrepresented.
      if (this.hasSaveBtnTarget) this.saveBtnTarget.disabled = false
    }
  }
}
